import { extendTheme } from '@chakra-ui/react';
import * as components from './components';
import colors from './foundations/colors';
import fonts from './foundations/fonts';
import shadows from './foundations/shadows';
import styles from './foundations/styles';
import tokens from './foundations/tokens';

export const theme: Record<string, any> = extendTheme({
  colors,
  components,
  fonts,
  semanticTokens: tokens,
  shadows,
  styles,
});
